import { useUserRoleStore } from "@main/stores/useUserRoleStore";
import type { Directive } from "vue";

type PermissionValue = string | string[];

const getMenuPermissions = () => {
	const userRoleStore = useUserRoleStore();
	const permissions = new Set<string>();

	const traverse = (items: typeof userRoleStore.menuList) => {
		for (const item of items) {
			if (item.rule_value) {
				permissions.add(item.rule_value);
			}

			if (item.children?.length) {
				traverse(item.children);
			}
		}
	};

	traverse(userRoleStore.menuList);

	return permissions;
};

const hasPermission = (permissionValue: PermissionValue) => {
	const userRoleStore = useUserRoleStore();
	const menuPermissions = getMenuPermissions();
	const allPermissions = new Set<string>([...menuPermissions, ...userRoleStore.btnTags]);
	const values = Array.isArray(permissionValue) ? permissionValue : [permissionValue];

	return values.some((value) => allPermissions.has(value));
};

const toggleDisplay = (el: HTMLElement, visible: boolean) => {
	if (visible) {
		const originalDisplay = el.dataset.permissionOriginalDisplay;

		el.style.display = originalDisplay ?? "";

		return;
	}

	if (!el.dataset.permissionOriginalDisplay) {
		el.dataset.permissionOriginalDisplay = el.style.display;
	}

	el.style.display = "none";
};

const permissionDirective: Directive<HTMLElement, PermissionValue> = {
	mounted(el, binding) {
		const value = binding.value;

		if (!value || (Array.isArray(value) && value.length === 0)) {
			return;
		}

		toggleDisplay(el, hasPermission(value));
	},
	updated(el, binding) {
		const value = binding.value;

		if (!value || (Array.isArray(value) && value.length === 0)) {
			toggleDisplay(el, true);

			return;
		}

		toggleDisplay(el, hasPermission(value));
	},
};

export default permissionDirective;
